import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Globe } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { viewerTz, participantSeesLabel } from '../utils/timeZone';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Shows staff what time the participant will see for the picked time
export const ParticipantSeesLine = ({ participantId, date, time }) => {
  const { user } = useAuth();
  const [tz, setTz] = useState(undefined);
  useEffect(() => {
    if (!participantId) { setTz(undefined); return; }
    axios.get(`${API}/participants/${participantId}`).then((r) => setTz(r.data?.time_zone || null)).catch(() => setTz(null));
  }, [participantId]);
  if (!participantId || !date || !time || tz === undefined) return null;
  const staff = viewerTz(user);
  return (
    <p className="text-xs text-muted-foreground flex items-center gap-1" data-testid="participant-sees-line">
      <Globe className="w-3 h-3" />
      Participant sees: <span className="font-medium text-foreground">{participantSeesLabel(date, time, staff, tz)}</span>
      {!tz && <span className="text-amber-600" data-testid="participant-tz-not-set">(participant's time zone isn't set, using yours)</span>}
    </p>
  );
};
